import { grey } from '@material-ui/core/colors'

export default {
    color: grey[500],
    minHeight: 70,
}
